module.exports = __webpack_public_path__ + "579819a2b25c8a78539beba7bd177525.png";